import { isRef, unref, isReactive, toRaw, onMounted, onUnmounted, ref, computed, nextTick, inject, provide, readonly, defineComponent, watch, createElementBlock, openBlock, normalizeStyle, createBlock, createCommentVNode, createVNode, createElementVNode, normalizeClass, toDisplayString } from "vue";
import { unpackParameterRecord, ParameterRecordBuilder, packRecord } from "@robovision/data";
import { Api, HubBuildState } from "@robovision/hub";
import { useDarkMode, ValidationBuilder, Validation } from "@robovision/rvai-base";
import { componentProps } from "@robovision/rvai-params";
import useVuelidate from "@vuelidate/core";
import { QSkeleton, QDialog, QIcon } from "quasar";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
var DaemonEventType = /* @__PURE__ */ ((DaemonEventType2) => {
  DaemonEventType2["DaemonDimensionsUpdated"] = "daemonDimensionsUpdated";
  DaemonEventType2["DaemonLoaded"] = "daemonLoaded";
  DaemonEventType2["DaemonReady"] = "daemonReady";
  DaemonEventType2["DaemonToggleFullscreen"] = "daemonToggleFullscreen";
  DaemonEventType2["DaemonValueUpdated"] = "daemonValueUpdated";
  return DaemonEventType2;
})(DaemonEventType || {});
var PlatformEventType = /* @__PURE__ */ ((PlatformEventType2) => {
  PlatformEventType2["PlatformContextUpdated"] = "platformContextUpdated";
  PlatformEventType2["PlatformInitialize"] = "platformInitialize";
  PlatformEventType2["PlatformIsValid"] = "platformIsValid";
  PlatformEventType2["PlatformPropsUpdated"] = "platformPropsUpdated";
  PlatformEventType2["PlatformThemeUpdated"] = "platformThemeUpdated";
  PlatformEventType2["PlatformValueUpdated"] = "platformValueUpdated";
  PlatformEventType2["PlatformWidgetAnnotationsChanged"] = "platformWidgetAnnotationsChanged";
  PlatformEventType2["PlatformWidgetInitialize"] = "platformWidgetInitialize";
  PlatformEventType2["PlatformWidgetPropsUpdated"] = "platformWidgetPropsUpdated";
  return PlatformEventType2;
})(PlatformEventType || {});
var HttpStatusCode;
(function(HttpStatusCode2) {
  HttpStatusCode2[HttpStatusCode2["CONTINUE"] = 100] = "CONTINUE";
  HttpStatusCode2[HttpStatusCode2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HttpStatusCode2[HttpStatusCode2["PROCESSING"] = 102] = "PROCESSING";
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["CREATED"] = 201] = "CREATED";
  HttpStatusCode2[HttpStatusCode2["ACCEPTED"] = 202] = "ACCEPTED";
  HttpStatusCode2[HttpStatusCode2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatusCode2[HttpStatusCode2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatusCode2[HttpStatusCode2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HttpStatusCode2[HttpStatusCode2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HttpStatusCode2[HttpStatusCode2["MULTI_STATUS"] = 207] = "MULTI_STATUS";
  HttpStatusCode2[HttpStatusCode2["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
  HttpStatusCode2[HttpStatusCode2["IM_USED"] = 226] = "IM_USED";
  HttpStatusCode2[HttpStatusCode2["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
  HttpStatusCode2[HttpStatusCode2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HttpStatusCode2[HttpStatusCode2["FOUND"] = 302] = "FOUND";
  HttpStatusCode2[HttpStatusCode2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HttpStatusCode2[HttpStatusCode2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HttpStatusCode2[HttpStatusCode2["USE_PROXY"] = 305] = "USE_PROXY";
  HttpStatusCode2[HttpStatusCode2["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
  HttpStatusCode2[HttpStatusCode2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatusCode2[HttpStatusCode2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatusCode2[HttpStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode2[HttpStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatusCode2[HttpStatusCode2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HttpStatusCode2[HttpStatusCode2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode2[HttpStatusCode2["GONE"] = 410] = "GONE";
  HttpStatusCode2[HttpStatusCode2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HttpStatusCode2[HttpStatusCode2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
  HttpStatusCode2[HttpStatusCode2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatusCode2[HttpStatusCode2["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
  HttpStatusCode2[HttpStatusCode2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HttpStatusCode2[HttpStatusCode2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
  HttpStatusCode2[HttpStatusCode2["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatusCode2[HttpStatusCode2["LOCKED"] = 423] = "LOCKED";
  HttpStatusCode2[HttpStatusCode2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
  HttpStatusCode2[HttpStatusCode2["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatusCode2[HttpStatusCode2["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatusCode2[HttpStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatusCode2[HttpStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatusCode2[HttpStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatusCode2[HttpStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HttpStatusCode2[HttpStatusCode2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatusCode2[HttpStatusCode2["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
  HttpStatusCode2[HttpStatusCode2["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
  HttpStatusCode2[HttpStatusCode2["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
  HttpStatusCode2[HttpStatusCode2["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
  HttpStatusCode2[HttpStatusCode2["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));
var DateTemplates;
(function(DateTemplates2) {
  DateTemplates2["Days"] = "MMMM d";
  DateTemplates2["Long"] = "yyyy-MM-dd HH:mm:ss";
  DateTemplates2["Short"] = "yyyy-MM-dd";
})(DateTemplates || (DateTemplates = {}));
({
  isMac: (() => {
    try {
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    } catch {
      return false;
    }
  })()
});
new Intl.Collator(void 0, {
  numeric: true,
  sensitivity: "base"
}).compare;
function isPlainObject(value) {
  if (typeof value !== "object" || value === null)
    return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}
function toRawDeep(value) {
  if (isRef(value))
    return toRawDeep(unref(value));
  const raw = isReactive(value) ? toRaw(value) : value;
  if (Array.isArray(raw)) {
    return raw.map((item) => toRawDeep(item));
  }
  if (isPlainObject(raw)) {
    return Object.fromEntries(Object.entries(raw).map(([key, val]) => [key, toRawDeep(val)]));
  }
  return raw;
}
function useDaemonMessaging(listeners) {
  let __seq = 0;
  function buildEmit(type) {
    return (value) => {
      return new Promise((resolve) => {
        const seq = ++__seq;
        const handler = (event2) => {
          const eventData = event2?.data;
          if (eventData?.type === type && eventData.__seq === seq) {
            window.removeEventListener("message", handler, false);
            resolve(eventData.value);
          }
        };
        window.addEventListener("message", handler, false);
        const event = {
          __seq: seq,
          type,
          value
        };
        window.parent.postMessage(toRawDeep(event), "*");
      });
    };
  }
  async function messageHandler(event) {
    const eventData = event.data;
    const callback = listeners[eventData.type];
    if (!callback) return;
    const result = await callback(eventData.value);
    const resultEvent = {
      __seq: eventData.__seq,
      type: eventData.type,
      value: result
    };
    window.parent.postMessage(toRawDeep(resultEvent), "*");
  }
  onMounted(() => {
    window.addEventListener("message", messageHandler, false);
  });
  onUnmounted(() => {
    window.removeEventListener("message", messageHandler, false);
  });
  return {
    emitDimensionsUpdated: buildEmit(DaemonEventType.DaemonDimensionsUpdated),
    emitLoaded: buildEmit(DaemonEventType.DaemonLoaded),
    emitReady: buildEmit(DaemonEventType.DaemonReady),
    emitToggleFullscreen: buildEmit(DaemonEventType.DaemonToggleFullscreen),
    emitValueUpdated: buildEmit(DaemonEventType.DaemonValueUpdated)
  };
}
function useDaemon({
  deferLoadEvent = false,
  handlesValidationMessage = false,
  wrapperRef
}) {
  const { set: setDarkMode } = useDarkMode();
  const disabledRef = ref(false);
  const fullscreenRef = ref(false);
  const parameterDefinitionRef = ref();
  const parameterContextRef = ref();
  const parameterValueRef = ref();
  const readOnlyRef = ref(false);
  const validationRef = ref();
  const valueOnlyRef = ref(false);
  const parameterValue = computed({
    get() {
      return parameterValueRef.value;
    },
    set(value) {
      void updateValue(value);
    }
  });
  const messaging = useDaemonMessaging({
    [PlatformEventType.PlatformContextUpdated]: async (msg) => {
      parameterContextRef.value = msg.parameterContext;
    },
    [PlatformEventType.PlatformInitialize]: async (msg) => {
      disabledRef.value = msg.disabled;
      fullscreenRef.value = msg.fullscreen;
      parameterContextRef.value = msg.parameterContext;
      parameterDefinitionRef.value = msg.parameterDefinition;
      readOnlyRef.value = msg.readonly;
      parameterValueRef.value = await deserializeValue(msg.value);
      valueOnlyRef.value = msg.valueOnly;
      if (!deferLoadEvent) {
        messaging.emitLoaded({});
        void nextTick(() => {
          messaging.emitDimensionsUpdated({
            height: wrapperRef?.value?.offsetHeight
          });
        });
      }
    },
    [PlatformEventType.PlatformIsValid]: async () => {
      const validation = validationRef.value?.value;
      if (!validation) return { valid: true };
      const valid = await validation.$validate();
      if (valid) return { valid: true };
      if (handlesValidationMessage) return { valid: false };
      const reason = validation.$errors?.[0]?.$message ?? validation.$silentErrors?.[0]?.$message;
      return {
        reason: typeof reason === "string" ? reason : reason?.value,
        valid: false
      };
    },
    [PlatformEventType.PlatformPropsUpdated]: async (msg) => {
      disabledRef.value = msg.disabled;
      fullscreenRef.value = msg.fullscreen;
      readOnlyRef.value = msg.readonly;
      valueOnlyRef.value = msg.valueOnly;
    },
    [PlatformEventType.PlatformThemeUpdated]: async (msg) => {
      setDarkMode(msg.isDark);
    },
    [PlatformEventType.PlatformValueUpdated]: async (msg) => {
      parameterValueRef.value = await deserializeValue(msg.value);
    }
  });
  async function deserializeValue(buffer) {
    const paramKey = parameterDefinitionRef.value?.key;
    if (!paramKey || !buffer) return void 0;
    const parameterRecord = await unpackParameterRecord(buffer);
    const value = parameterRecord.parameters.find((p) => p.key === paramKey)?.value;
    return value;
  }
  async function updateValue(value, isDefaultValue) {
    if (!parameterDefinitionRef.value) return;
    const record = ParameterRecordBuilder.withLogicalType("param").addParameters({
      ...value && {
        [parameterDefinitionRef.value.key]: value
      }
    }).build();
    const newValue = await packRecord(record);
    await messaging.emitValueUpdated({
      isDefaultValue,
      value: newValue
    });
  }
  onMounted(() => messaging.emitReady({}));
  return {
    disabled: computed(() => disabledRef.value),
    fullscreen: computed(() => fullscreenRef.value),
    messaging,
    parameterContext: computed(() => parameterContextRef.value),
    parameterDefinition: computed(() => parameterDefinitionRef.value),
    parameterValue,
    readOnly: computed(() => readOnlyRef.value),
    updateValue,
    validationRef,
    valueOnly: computed(() => valueOnlyRef.value)
  };
}
function useDaemonWidget({
  deferLoadEvent = false,
  onAnnotationsUpdate
}) {
  const { set: setDarkMode } = useDarkMode();
  const contextRef = ref();
  const fullscreenRef = ref();
  const sampleFiltersRef = ref();
  const isSplitView = ref();
  const messaging = useDaemonMessaging({
    [PlatformEventType.PlatformContextUpdated]: (msg) => {
      contextRef.value = msg.widgetContext;
    },
    [PlatformEventType.PlatformWidgetInitialize]: (msg) => {
      if (!deferLoadEvent) {
        messaging.emitLoaded({});
      }
      contextRef.value = msg.widgetContext;
      fullscreenRef.value = msg.fullscreen;
      isSplitView.value = msg.isSplitView;
      sampleFiltersRef.value = msg.sampleFilters;
    },
    [PlatformEventType.PlatformWidgetPropsUpdated]: (msg) => {
      sampleFiltersRef.value = msg.sampleFilters;
      isSplitView.value = msg.isSplitView;
    },
    [PlatformEventType.PlatformWidgetAnnotationsChanged]: onAnnotationsUpdate,
    [PlatformEventType.PlatformThemeUpdated]: (msg) => {
      setDarkMode(msg.isDark);
    }
  });
  onMounted(() => messaging.emitReady({}));
  return {
    context: computed(() => contextRef.value),
    fullscreen: computed(() => fullscreenRef.value),
    isSplitView: computed(() => isSplitView.value),
    messaging,
    sampleFiltersRef: computed(() => sampleFiltersRef.value)
  };
}
const ParameterContextDep = /* @__PURE__ */ Symbol("ModelsChart dependency");
function buildComposable(value = {}) {
  const parameterContext = ref(value);
  async function updateParameterContext(valueOrPromise) {
    const value2 = await valueOrPromise;
    parameterContext.value = value2;
  }
  return {
    parameterContext: readonly(parameterContext),
    updateParameterContext
  };
}
function provideParameterContext(parameterContext) {
  const composable = buildComposable(parameterContext);
  provide(ParameterContextDep, composable);
  return composable;
}
function useParameterContext() {
  const composable = inject(ParameterContextDep, void 0);
  if (!composable) {
    console.error("Invalid use of `useParameterContext`. Did you forget to use `provideParameterContext`?");
  }
  return composable;
}
function usePlatformMessaging(listeners) {
  let __seq = 0;
  const iframeRef = ref();
  function buildEmit(type) {
    return (value) => {
      return new Promise((resolve) => {
        const seq = ++__seq;
        const handler = (event2) => {
          const eventData = event2?.data;
          if (eventData?.type === type && eventData.__seq === seq) {
            window.removeEventListener("message", handler, false);
            resolve(eventData.value);
          }
        };
        window.addEventListener("message", handler, false);
        const event = {
          __seq: seq,
          type,
          value
        };
        iframeRef.value?.contentWindow?.postMessage(toRawDeep(event), "*");
      });
    };
  }
  async function messageHandler(event) {
    if (!iframeRef.value || event.source !== iframeRef.value.contentWindow) return;
    const eventData = event.data;
    const callback = listeners[eventData.type];
    if (!callback) return;
    const result = await callback(eventData.value);
    const resultEvent = {
      __seq: eventData.__seq,
      type: eventData.type,
      value: result
    };
    iframeRef.value?.contentWindow?.postMessage(toRawDeep(resultEvent), "*");
  }
  onMounted(() => {
    window.addEventListener("message", messageHandler, false);
  });
  onUnmounted(() => {
    window.removeEventListener("message", messageHandler, false);
  });
  return {
    emitContextUpdated: buildEmit(PlatformEventType.PlatformContextUpdated),
    emitInitialize: buildEmit(PlatformEventType.PlatformInitialize),
    emitIsValid: buildEmit(PlatformEventType.PlatformIsValid),
    emitPropsUpdated: buildEmit(PlatformEventType.PlatformPropsUpdated),
    emitThemeUpdated: buildEmit(PlatformEventType.PlatformThemeUpdated),
    emitValueUpdated: buildEmit(PlatformEventType.PlatformValueUpdated),
    emitWidgetAnnotationsChanged: buildEmit(PlatformEventType.PlatformWidgetAnnotationsChanged),
    emitWidgetInitialize: buildEmit(PlatformEventType.PlatformWidgetInitialize),
    emitWidgetPropsUpdated: buildEmit(PlatformEventType.PlatformWidgetPropsUpdated),
    iframeRef
  };
}
const _hoisted_1 = ["height", "src"];
const _hoisted_2 = {
  key: 1,
  class: "deamon-param__info flex no-wrap q-mb-sm rounded-borders q-px-md q-py-sm"
};
const _hoisted_3 = { class: "q-ml-sm text-small" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DaemonParam",
  props: {
    ...componentProps
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { isDark } = useDarkMode();
    const paramContext = useParameterContext();
    const i18nInstance = useI18n();
    const { t: $t } = i18nInstance;
    const daemonUrl = ref();
    const loading = ref(true);
    const fullscreen = ref(false);
    const algorithmError = ref();
    const height = ref();
    const errorMessage = ref();
    const {
      emitContextUpdated,
      emitInitialize,
      emitIsValid,
      emitPropsUpdated,
      emitThemeUpdated,
      emitValueUpdated,
      iframeRef
    } = usePlatformMessaging({
      [DaemonEventType.DaemonDimensionsUpdated]: (msg) => {
        height.value = msg.height;
      },
      [DaemonEventType.DaemonLoaded]: async () => {
        loading.value = false;
        v$.value.modelValue.$reset();
        v$.value.modelValue.$touch();
      },
      [DaemonEventType.DaemonReady]: async () => {
        const value = await serializeValue(props.modelValue);
        await emitInitialize({
          disabled: props.disable,
          fullscreen: fullscreen.value,
          parameterContext: toRaw(paramContext?.parameterContext.value),
          parameterDefinition: props.definition,
          readonly: props.readonly,
          value,
          valueOnly: props.valueOnly
        });
      },
      [DaemonEventType.DaemonToggleFullscreen]: (msg) => {
        fullscreen.value = msg.fullscreen ?? !fullscreen.value;
      },
      [DaemonEventType.DaemonValueUpdated]: async (msg) => {
        v$.value.modelValue.$touch();
        const value = await deserializeValue(msg.value);
        emit("update:modelValue", value, msg.isDefaultValue);
      }
    });
    const rules = {
      modelValue: ValidationBuilder.withLabel("Value", i18nInstance).customAsync(
        async () => {
          if (loading.value) return true;
          const result = await emitIsValid();
          errorMessage.value = result.valid ? void 0 : result.reason;
          return result.valid;
        },
        (() => errorMessage.value)
      ).rules
    };
    const v$ = useVuelidate(
      rules,
      computed(() => ({ modelValue: props.modelValue }))
    );
    async function deserializeValue(buffer) {
      if (!buffer) return void 0;
      const parameterRecord = await unpackParameterRecord(buffer);
      const value = parameterRecord.parameters.find((p) => p.key === props.definition.key)?.value;
      return value;
    }
    function getAlgorithmErrorMessage(algorithmBuildState) {
      switch (algorithmBuildState) {
        case HubBuildState.DELETED:
        case HubBuildState.DELETING:
          return $t("rvai-params-daemon.algorithmDeleted");
        case HubBuildState.PENDING:
          return $t("rvai-params-daemon.algorithmInstalling");
        case HubBuildState.FAILED:
        default:
          return $t("rvai-params-daemon.algorithmFailed");
      }
    }
    async function serializeValue(value) {
      if (!value) return void 0;
      const record = ParameterRecordBuilder.withLogicalType("param").addParameter(props.definition.key, value).build();
      return packRecord(record);
    }
    watch(() => props.modelValue, async (value) => {
      const newValue = await serializeValue(value);
      await emitValueUpdated({
        value: newValue
      });
      v$.value.modelValue.$reset();
      v$.value.modelValue.$touch();
    });
    const route = useRoute();
    const projectSource = computed(() => {
      if (props.project) {
        return {
          project: props.project,
          type: "props"
        };
      }
      if (route.params.projectName && typeof route.params.projectName === "string") {
        return {
          projectName: route.params.projectName,
          type: "route"
        };
      }
      return null;
    });
    async function loadProject(hubApi, projectSource2) {
      if (projectSource2.type === "props") {
        return projectSource2.project;
      }
      const { data } = await hubApi.projects.getProjectByName(projectSource2.projectName);
      return data;
    }
    watch(projectSource, async (projectSource2) => {
      if (!projectSource2) {
        daemonUrl.value = "";
        return;
      }
      const hubApi = new Api();
      const project = await loadProject(hubApi, projectSource2);
      if (!project.defaultAlgorithmId) throw new Error(`Project ${project.id} does not have a default algorithm`);
      if (!project.defaultAlgorithmVersion) throw new Error(`Project ${project.id} does not have a default algorithm`);
      const {
        daemonId,
        daemonSubpath
      } = props.definition.daemon;
      try {
        const { data } = await hubApi.algorithms.getDaemon(
          project.defaultAlgorithmId,
          project.defaultAlgorithmVersion,
          daemonId
        );
        if (!data?.url) throw new Error("Missing daemon url");
        daemonUrl.value = data.url + (daemonSubpath ?? "");
      } catch {
        loading.value = false;
        const { data: algorithm } = await hubApi.algorithms.getAlgorithm(
          project.defaultAlgorithmId,
          project.defaultAlgorithmVersion
        );
        algorithmError.value = getAlgorithmErrorMessage(algorithm.buildState);
      }
    }, {
      immediate: true
    });
    if (paramContext) {
      watch(paramContext.parameterContext, (parameterContext) => {
        emitContextUpdated({
          parameterContext: toRaw(parameterContext)
        });
      });
    }
    watch(isDark, () => {
      emitThemeUpdated({ isDark: isDark.value });
    }, { immediate: true });
    watch(() => [
      props.disable,
      fullscreen.value,
      props.readonly,
      props.valueOnly
    ], () => {
      emitPropsUpdated({
        disabled: props.disable,
        fullscreen: fullscreen.value,
        readonly: props.readonly,
        valueOnly: props.valueOnly
      });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "daemon-param",
        "data-automation": "daemon-param",
        style: normalizeStyle({
          minHeight: height.value && `${height.value}px`
        })
      }, [
        loading.value ? (openBlock(), createBlock(unref(QSkeleton), {
          key: 0,
          "data-automation": "daemon-param__loading",
          square: ""
        })) : createCommentVNode("", true),
        createVNode(unref(QDialog), {
          modelValue: fullscreen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => fullscreen.value = $event),
          class: "invisible"
        }, null, 8, ["modelValue"]),
        createElementVNode("div", {
          class: normalizeClass({
            "fixed-full z-max": fullscreen.value
          }),
          "data-automation": "daemon-param__wrapper"
        }, [
          createElementVNode("iframe", {
            ref_key: "iframeRef",
            ref: iframeRef,
            class: normalizeClass(["daemon-param__iframe block non-selectable", {
              "daemon-param__iframe--hidden": loading.value,
              hidden: !daemonUrl.value
            }]),
            "data-automation": "daemon-param__iframe",
            frameborder: "0",
            height: !fullscreen.value ? height.value ?? "100%" : "100%",
            src: daemonUrl.value,
            width: "100%"
          }, null, 10, _hoisted_1),
          createVNode(unref(Validation), {
            "data-automation": "daemon-param__validation",
            validation: unref(v$).modelValue
          }, null, 8, ["validation"])
        ], 2),
        !loading.value && algorithmError.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
          createVNode(unref(QIcon), {
            class: "daemon-param__algo-installing",
            color: "blue",
            name: "rvai-base:info",
            size: "20px"
          }),
          createElementVNode("div", _hoisted_3, toDisplayString(algorithmError.value), 1)
        ])) : createCommentVNode("", true)
      ], 4);
    };
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const DaemonParamVue = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b0e34397"]]);
const DaemonParam = {
  component: DaemonParamVue,
  supports(definition) {
    return !!definition.daemon;
  }
};
const daemonMessages = {
  "rvai-params-daemon": {
    algorithmDeleted: "The data cannot be displayed because the algorithm for this project was deleted.",
    algorithmFailed: "Looks like something went wrong.",
    algorithmInstalling: "The algorithm hasn't finished installing yet. Please come back a little later."
  }
};
function initializeI18n() {
  const i18n = useI18n();
  i18n.mergeLocaleMessage("en", daemonMessages);
}
function initialize() {
  initializeI18n();
}
export {
  DaemonEventType,
  DaemonParam,
  PlatformEventType,
  initialize,
  provideParameterContext,
  useDaemon,
  useDaemonMessaging,
  useDaemonWidget,
  useParameterContext,
  usePlatformMessaging
};
//# sourceMappingURL=index.es.js.map
